import React, { useEffect, useState } from 'react';
import database from './firebaseConfig';
import { ref, set, child, onDisconnect } from 'firebase/database';
import { v4 as uuidv4 } from 'uuid';
import useMousePosition from './useMousePosition.js';
import { useList } from 'react-firebase-hooks/database';

// map of key to color
const colors = {
    0: 'blue',
    1: 'green',
    2: 'red',
    3: 'orange',
    4: 'purple',
    5: 'red',
    6: 'pink',
    7: 'brown',
    8: 'gray',
    9: 'magenta',
};

const calculateDistance = (a, b) => {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
};

const CursorTracker = () => {
    const [cursors, setCursors] = useState({});
    const [objects, setObjects] = useState({});
    const [userId] = useState(uuidv4()); // Generate a unique ID for each client

    const mousePosition = useMousePosition();

    const cursorRef = ref(database, 'cursors');
    const [cursorsSnapshots, loading, error] = useList(cursorRef);

    useEffect(() => {
        const newObjects = {}
        for (let i = 0; i < 5; i++) {
            newObjects[i] = { x: Math.random() * 500, y: Math.random() * 500 };
        }
        setObjects(newObjects);

        onDisconnect(child(cursorRef, userId)).remove();
    }, []);

    useEffect(() => {
        // compute the estimated cursor position by weighing the positions of the objects by their distance
        const newCursors = {};
        console.log("---")
        console.log(Array.from(cursorsSnapshots.keys()));
        console.log(cursorsSnapshots.length);
        const alreadySeenCursor = new Set();
        cursorsSnapshots.forEach((snapshot) => {
            const cursor = snapshot.val();
            
            // Doing this because we get duplicate snapshots for some reason
            if (alreadySeenCursor.has(snapshot.key)) {
                return;
            }
            alreadySeenCursor.add(snapshot.key);

            const distances = cursor.distances;
            console.log(snapshot.key);
            console.log(distances);
            let x = 0;
            let y = 0;
            let totalWeight = 0;
            Object.entries(distances).forEach(([key, distance]) => {
                const weight = 1 / Math.max(0, distance - 15);
                // const weight = 1 / (distance * distance);
                x += objects[key].x * weight;
                y += objects[key].y * weight;
                totalWeight += weight;
            });
            x /= totalWeight;
            y /= totalWeight;
            newCursors[snapshot.key] = { x, y };
        });
        //console.log(newCursors);
        setCursors(newCursors);
        console.log("---")
    }, [cursorsSnapshots, objects]);

    useEffect(() => {
        const distances = {};
        Object.entries(objects).map(([key, object]) => {
            distances[key] = calculateDistance({ x: mousePosition.x, y: mousePosition.y }, object);
        });
        set(child(child(cursorRef, userId), 'distances'), distances);
        set(child(child(cursorRef, userId), "positions"), { x: mousePosition.x, y: mousePosition.y });
    }, [mousePosition, cursorRef, objects, userId]);

    return (
        <div>
            <div
                style={{
                    position: 'absolute',
                    left: mousePosition.x - 10,
                    top: mousePosition.y - 10,
                    height: '20px',
                    width: '20px',
                    backgroundColor: 'black',
                    borderRadius: '50%',
                    zIndex: 100,
                }}
            ></div>
            {
                Object.entries(cursors).map(([key, cursor]) => (
                    userId !== key && (
                        <div
                            key={key}
                            style={{
                                position: 'absolute',
                                left: cursor.x - 10,
                                top: cursor.y - 10,
                                height: '20px',
                                width: '20px',
                                backgroundColor: 'black',
                                borderRadius: '50%',
                                zIndex: 100,
                            }}
                        ></div>
                    )
                ))
            }
            {Object.entries(objects).map(([key, object]) => (
                <div
                    key={key}
                    style={{
                        position: 'absolute',
                        left: object.x - 15,
                        top: object.y - 15,
                        height: '30px',
                        width: '30px',
                        backgroundColor: colors[key],
                        borderRadius: '10%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <span style={{ color: 'white', fontWeight: 'bold' }}>{key}</span>
                </div>
            ))}
        </div>
    );
};

export default CursorTracker;
